import { html, nothing } from 'lit';

/**
 * Canonical class of every repair-action button. Logging and diagnostics find
 * repair buttons by this class and read the triggered action from
 * `data-repair-action`; every click also leaves a `sl-repair-action:<id>`
 * performance mark.
 */
export const REPAIR_ACTION_CLASS = 'sl-repair-action';

export type RepairActionId =
  | 'database.restore'
  | 'database.report'
  | 'database.refused-changes.discard'
  | 'database.refused-changes.discard-ask'
  | 'database.refused-changes.keep'
  | 'database.refused-changes.resend'
  | 'database.shard-manifest';

export type RepairActionButtonOptions = {
  action: RepairActionId;
  label: string;
  onClick: (event: MouseEvent) => void;
  /** Visual class of the host surface, added next to the canonical class. */
  className?: string;
  disabled?: boolean;
  testId?: string;
};

export function markRepairAction(action: RepairActionId): void {
  performance.mark(`${REPAIR_ACTION_CLASS}:${action}`);
}

export function repairActionButton(options: RepairActionButtonOptions) {
  const onClick = (event: MouseEvent) => {
    markRepairAction(options.action);
    options.onClick(event);
  };
  return html`
    <button
      type="button"
      class="${REPAIR_ACTION_CLASS} ${options.className ?? ''}"
      data-repair-action=${options.action}
      data-testid=${options.testId ?? nothing}
      ?disabled=${options.disabled ?? false}
      @click=${onClick}
    >
      ${options.label}
    </button>
  `;
}
